import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ArbreComposant } from 'src/app/model/arbre/arbre-composant';
import { TreeService } from 'src/app/services/http/tree/tree.service';

export const PARENT: number  = 1;
export const CHILD: number   = 2;


export interface ElementChooserData {
  composant : ArbreComposant;
  typeOfLink: number;

}

@Component({
  selector: 'app-element-chooser',
  templateUrl: './element-chooser.component.html',
  styleUrls: ['./element-chooser.component.scss']
})
export class ElementChooserComponent implements OnInit {

public potentialComponents  : ArbreComposant[] = [];

  constructor(public dialogRef: MatDialogRef<ElementChooserData>, 
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: ElementChooserData,
    public treeService: TreeService) { }

  ngOnInit(): void { 
    if ( this.data.composant) {
      if( this.data.typeOfLink == PARENT ) {
        this.treeService.getPotentialParents( this.data.composant.type ).then(parents =>{
          this.potentialComponents = parents.filter(element =>{ 
              return element.id != this.data.composant.parent_id 
          });
        /** If looking for parents of Solution, we remove elements with type Solution (Solution has Solution as children type)*/
          if( this.data.composant.type == 'Solution') {
            this.potentialComponents = this.potentialComponents.filter(element => {
                return element.type != 'Solution';
            })  
          }
          //console.log(this.potentialComponents);
        })
       

      } else {
          this.treeService.getPotentialChildren( this.data.composant.children_type ).then(children =>{
          this.potentialComponents = children.filter(child => { 
            return !this.data.composant.children_id.includes( child.id.toString() )
          });
        })
      }   
    } 
  }

  makeLink( componentToLink: ArbreComposant ): void {
    console.log( componentToLink.id.toString());
    if( this.data.typeOfLink == PARENT ){
      this.data.composant.parent_id = componentToLink.id;
    } else {
      this.data.composant.children_id.push( componentToLink.id.toString() );
    }
      console.log(this.data.composant)
    this.dialogRef.close({relation: this.data.typeOfLink, data:this.data.composant});
  }

}
